$(document).ready(function() {
    
    $(".selectpicker").each(() => {
        $(this).selectpicker();
    });

    if (jQuery.ui) {
        $(".autocomplete-phrase").autocomplete({
            delay: 500,
            minLength: 2,
            source: "/ajax/autoPhrase"
        });
        $(".autocomplete-location").autocomplete({
            delay: 500,
            minLength: 2,
            source: "/ajax/autoLocation"
        });
    }

    // Fixed Header
    if ($('header.fixed-top + .fixed-spacer').length > 0) {
        adjustFixedSpacer();
        $(window).on('resize', adjustFixedSpacer);
        $('header.fixed-top .navbar-toggler-icon').on("click", adjustFixedSpacer);
    }

    // Alter Cookie Hinweis
    var hint_seen = getCookie("cookiehint_seen");
    if (hint_seen != 1) {
        $(".cookiehint-old").css("display", "block");
    }
    $("#cookiehint-seen").click(function(){
        setCookie("cookiehint_seen", 1, 365);
        if ($(".cookiehint-old").css('position') == 'fixed') {
            $(".cookiehint-old").hide();
        } else {

            $(".cookiehint-old").slideUp();
        }
    });

    // Cookie-Einstellungen
    $(".cookiehint-wrapper").each(function() {
        let show = false;
        let cookie = getCookie("cookie_settings");
        if (cookie.length > 0) {
            let decoded = JSON.parse(atob(decodeURIComponent(cookie)));
            $(".cookiehint-inner .cookie").each(function() {
                if (decoded.settings.indexOf($(this).data("identifier")) >= 0) {
                    $(this).find(".switch input").prop("checked", true);
                }
            });
            $(".cookiehint-inner .card").each(function() {
                let unchecked = $(this).find(".cookie .switch input:not(:checked)").length;
                $(this).find(".card-header .switch input").prop("checked", !unchecked)
            });
            if (new Date($(this).data("timestamp")) > new Date(decoded.timestamp)) {
                show = true;
            }
        } else {
            show = true;
        }
        /*if ($(this).hasClass("hide")) {
            show = false;
        }*/
        $(this).toggleClass("show", show);
        $("body").toggleClass("no-scroll", show);
        return false;
    })

    $(".cookiehint-inner")
        .on("click", ".cookiehint-actions .all", function() {
            $(".cookiehint-inner").find(".card .switch input").prop("checked", true);
            $(".cookiehint-inner .cookiehint-actions .save").trigger("click");
        })
        .on("click", ".cookiehint-actions .save", function() {
            let settings = $(".cookiehint-inner .cookie").map(function() {
                if ($(this).find(".switch").length && $(this).find(".switch input").prop("checked")) {
                    return $(this).data("identifier");
                }
            }).toArray();

            let reload = false;

            let old = getCookie("cookie_settings");
            if (old.length > 0) {
                let decoded = JSON.parse(atob(decodeURIComponent(old)));
                if (JSON.stringify(decoded.settings) !== JSON.stringify(settings)) {
                    reload = true;
                }
            } else {
                reload = true;
            }

            let current = { timestamp: new Date().toISOString(), settings: settings };
            setCookie("cookie_settings", encodeURIComponent(btoa(JSON.stringify(current))), 365);
            
            if (reload) {
                window.location.reload();
            } else {
                $(".cookiehint-wrapper").toggleClass("show", false);
                $("body").toggleClass("no-scroll", false);
            }
        })
        .on("change", ".card-header .switch input", function() {
            $(this).parents(".card").find(".card-body .switch input").prop("checked", $(this).prop("checked"));
        })
        .on("change", ".cookie .switch input", function() {
            let parent    = $(this).parents(".card");
            let unchecked = parent.find(".cookie .switch input:not(:checked)").length;
            parent.find(".card-header .switch input").prop("checked", !unchecked)
        });

    $(".cookiehint-show").on("click", function(e) {
        e.preventDefault();
        $(".cookiehint-wrapper").toggleClass("show", true);
        $("body").toggleClass("no-scroll", true);
    })

    var tt_seen = getCookie("tt_seen");
    if (tt_seen == 1) {
        $(".tt").css("display", "none");
    }
    $("#tt-close").click(function(){
        setCookie("tt_seen", 1);
        $(".tt").fadeOut("slow");
    });

    // Datum umschreiben (schema.org)
    // $(".date-posted").each(function() {
    //     var date = new Date($(this).html());
    //     var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    //     $(this).html(date.toLocaleDateString("de-DE", options));
    // });

    // Schnellsuche
    $(".btn-search-qs").click(function(e) {
        e.preventDefault();

        var phrase = $("#qs-phrase").val();
        var ort = $("#qs-location").val();
        if (phrase == $("#qs-phrase").attr("placeholder")) phrase = "";
        if (ort == $("#qs-location").attr("placeholder")) ort = "";

        if (typeof(phrase) === "undefined") {
            phrase = "";
        } else {
            phrase = phrase.replace("&", " ");
        }
        if (typeof(ort) === "undefined") {
            ort = "";
        } else {
            ort = ort.replace("&", " ");
        }

        //vorherige Eingabe für Phrase/Ort dazu addieren
        let phrase_old = $("#qs-phrase_old").val();
        if (phrase_old !== undefined && phrase_old.length > 0) {
            phrase = [phrase_old, phrase].join(",");
        }
        let ort_old = $("#qs-location_old").val();
        if (ort_old !== undefined && ort_old.length > 0) {
            ort = [ort_old, ort].join(",");
        }

        if (phrase.length > 1 || ort.length > 1) {
            var url = "/suchergebnis?phrase=" + encodeURIComponent(phrase) + "&ort=" + encodeURIComponent(ort) + "&qs=1";
            location.href = url;
        }
    });

    // Schnellsuche mit Enter auslösen
    $("#qs-phrase, #qs-location").keypress(function(e) {
        if (e.which == "13") {
            e.preventDefault();
            $(".btn-search-qs").trigger("click");
        }
    });

    // Kombinierte Schnellsuche, Beruf und Ort in einem Feld
    if (!$(".fknd-job-nav").length) {
        $("#qs-combined").keypress(function (e) {
            if ($(this).val().length > 1 && e.which == '13') {
                var url = $("#result-listing-target").val() + "?qs_combined=" + encodeURIComponent($("#qs-combined").val()) + "&qs=1";
                location.href = url;
            }
        });
    
        $("#qs-combined").on("focusout", function (e) {
           if ($(this).val().length > 1) {
                var url = $("#result-listing-target").val() + "?qs_combined=" + encodeURIComponent($("#qs-combined").val()) + "&qs=1";
                location.href = url;
            }
        });
    }
    



    // Jobboards
    if ($("#jobboards").length !== 0) {
        $.ajax({
            type: "POST",
            url: "/ajax/jobboards",
            dataType: "json",
            data: { "source": window.location.href, "restock_radius": $("#jobboards").data("radius") },
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
        }).done(function(response, textStatus) {
            $("#jobboards-available").html(response.content);
        });
    }

    // Sources
    if ($("#sources.tipps").length !== 0) {
        let tipps = [];
        $("#sources.tipps .tipp").each(function() {
            let tipp = {};
            let jb = $(this).data("jb");
            let name = $(this).data("name");
            if (jb && name) {
                tipps.push({name: name, jb: jb});
            }
        });
        $.ajax({
            type: "POST",
            url: "/ajax/sources",
            dataType: "json",
            data: { "source": window.location.href, "tipps": JSON.stringify(tipps)},
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
        }).done(function(response, textStatus) {
            $("#sources.tipps .tag-cloud-content").empty();
            for (let i = 0; i < response.length; i++) {
                $("#sources.tipps .tag-cloud-content").append(
                    `<a href="${response[i].link}" rel="nofollow" class="tipp ${!response[i].hits || response[i].hits > 0 ? '' : 'zero'} ${response[i].active ? 'active' : 'inactive'}">${response[i].name} ${response[i].hits ? ' (' + response[i].hits + ')' : ''}</a>`
                );
            }
        });
    }

    // Kategorien
    if ($(".kat-tipps").length !== 0) {
        $(".kat-tipps").each(function() {
            $(this).append('<div class="container px-0 tipps"><div class="tag-cloud-headline active">' + $(this).data('label') + '</div><div class="tag-cloud-content text-center text-white"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></div></div>')
            $.ajax({
                type: "POST",
                url: "/ajax/kattipps",
                dataType: "json",
                data: { 'kat': $(this).data('kat'), 'group': $(this).data('group'), 'search': window.location.search, 'label': $(this).data('label'), 
                        'url': $(location).attr('pathname'), 'live': $(this).data('live') ? $(this).data('live') : 0, 'live_requests': $(this).data('live') ? $(this).data('live') : 0 },
                headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
                obj: this
            }).done(function(response, textStatus) {
                $(this.obj).html(response.content);
                if ($(this.obj).hasClass("collapsable")) {
                    makeTippCollapsable($(this.obj).find('.tipps'), $(this.obj).hasClass("show"));
                }
            }); 
        });
    }

    makeTippCollapsable($(".locs-tipps.collapsable .tipps"), $(".locs-tipps.collapsable").hasClass("show"));

    // Firmen
    if ($(".company-tipps").length !== 0) {
        $.ajax({
            type: "POST",
            url: "/ajax/companytipps",
            dataType: "json",
            data: { 'search': window.location.search, 'label': $(".company-tipps").data('label'), 'url': $(location).attr('pathname') },
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
        }).done(function(response, textStatus) {
            $(".company-tipps").html(response.content);
            makeTippCollapsable($(".company-tipps.collapsable .tipps"), $(".company-tipps.collapsable").hasClass("show"));
        });            
    }

    // Individuelle Polygone
    if ($(".userpoly-tipps").length !== 0) {
        $.ajax({
            type: "POST",
            url: "/ajax/userpoly",
            dataType: "json",
            data: { 'poly': $(".userpoly-tipps").data('poly'), 'search': window.location.search, 'label': $(".userpoly-tipps").data('label'), 'url': $(location).attr('pathname') },
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
        }).done(function(response, textStatus) {
            $(".userpoly-tipps").html(response.content);
            makeTippCollapsable($(".userpoly-tipps.collapsable .tipps"), $(".userpoly-tipps.collapsable").hasClass("show"));
        });           
    }


    /* Job als Mail-Link verschicken */
    $(".mailclient").click(function(){
        $.ajax({
            type: "POST",
            url: "/ajax/mailclient",
            dataType: "json",
            data: { id: $(this).data("id"), archive: 0 },
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
            success: function(response, textStatus) {
                window.location = response.mailto;
            }
        });         
    });

    /* Einzelnen Job zur Merkliste hinzu fügen */
    $("body").on('click', '.bookmarkjob', function() {
        if ($(this).hasClass("unchecked")) {
            $(this).removeClass("unchecked");
            $(this).addClass("checked");
            var j_id = $(this).data("id");
            var j_action = "add";
        } else {
            $(this).removeClass("checked");
            $(this).addClass("unchecked");
            var j_id = $(this).data("id");
            var j_action = "remove";
        }

        $.ajax({
            type: "POST",
            url: "/ajax/bookmark",
            dataType: "json",
            data: { id: j_id, action: j_action },
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
            target: this, 
            add: j_action == "add" ? true : false
        }).done(function(response, textStatus) {
            if (response.count == "0") {
                $(".bookmark-handle .counter").text("");
                if ($(".bm").hasClass("active")) {
                    $(".bm").removeClass("active");
                    $(".bm").addClass("inactive");
                }
            } else {
                $(".bookmark-handle .counter").text(response.count);
                if ($(".bm").hasClass("inactive")) {
                    $(".bm").removeClass("inactive");
                    $(".bm").addClass("active");
                }
            }
    
            $(".bookmark-handle").css(
                {"position": "relative"}
            ).animate(
                {"top": "-5px"},
                200
            ).animate(
                {"top": "0"},
                200, function() {
                    $(this).css({"position": "", "top": ""});
                }
            );
            /*
            if (this.add) {
                var orig = $(this.target).parents(".job").find(".logo img")
                var clone = orig.clone();
                clone.offset(orig.offset());
                clone.css({
                    "width": orig.width(),
                    "height": orig.height(),
                    "position": "absolute",
                    "opacity": "1"
                });
                clone.appendTo($("body"));
                clone.animate(
                    {"top": $(".content-header .bookmark-handle").offset().top, "left": $(".content-header .bookmark-handle").offset().left, "opacity": 0.5},
                    1000,
                    function() {
                        this.remove();
                        $(".bookmark-handle").css(
                            {"position": "relative"}
                        ).animate(
                            {"top": "-5px"},
                            200
                        ).animate(
                            {"top": "0"},
                            200, function() {
                                $(this).css({"position": "", "top": ""});
                            }
                        );
                    }
                );
            }
            */
        });
    });

    /* Bookmarks im Popup anzeigen */
    $('.bookmark-handle').click(function(){
        $.ajax({
            type: "POST",
            url: "/ajax/bookmarklist",
            dataType: "json",
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },            
            success: function(response, textStatus) {
                $("#bookmarklist").html(response.content);
            }
        }); 
    });

    /* Bookmarks als Ergebnis anzeigen, oder einzelne löschen */
    $('#bm-show-action, #bm-del-action').click(function(){
        var source = $(this).attr('id');
        var selected = new Array();
        $("input:checkbox[class=cb]:checked").each(function() {
            selected.push($(this).val());
        });
        $.ajax({
            type: "POST",
            url: "/ajax/bookmarkedit",
            dataType: "json",
            data: { bookmarks: selected, source: source }, 
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },            
            success: function(response, textStatus) {
                if (response.done == "show") {
                    location.href = "/merkliste?id=" + response.ids;
                }
                if (response.done == "del") {
                    location.reload();
                }
            }
        }); 
    });

    /* Mail Abo bestellen */
    $(".btn-subscribe").click(function(){

        $(".btn-subscribe").prop("disabled", true).addClass("disabled");

        $("#messages").slideUp("slow", function(){
            $("#messages").empty();

            var sec = ($("#sec-confirm").is(":checked")) ? 1 : 0;
            var sec_txt = $("#sec-confirm-text").html().replace(/<[^>]*>/ig, "");

            $.ajax({
                type: "POST",
                url: "/abo/subscribe",
                dataType: 'json',
                data: { "email": $('#email').val(), "params": $('#params').val(), "sec_confirm": sec, "sec_txt": sec_txt },
                headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }
            }).done(function(response, textStatus) {
                if (response.error) {
                    $("#messages").append('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Verwerfen"><span aria-hidden="true">&times;</span></button></div>');
                } else {
                    $("#abo-msg").html(response.msg);
                    $("#abo-form").hide();
                    $("#abo-success").show();
                    $("#abo-mail-sent").toggle(response.mail)
                    $("#mail_address_new").html(response.email);
                }
            }).fail(function(response, textStatus) {
                $("#messages").append('<div class="alert alert-danger alert-dismissible fade show" role="alert">Bei der Verarbeitung ist etwas schief gelaufen.<button type="button" class="close" data-dismiss="alert" aria-label="Verwerfen"><span aria-hidden="true">&times;</span></button></div>');
            }).always(function() {
                $("#messages").slideDown("slow");
                $(".btn-subscribe").prop("disabled", false).removeClass("disabled");
            });
        });
    });

    $('#save-my-abo').click(function(event){
        event.preventDefault();
        
        var fdata = {};
        $('.abo').each(function(){
            if ($(this).attr('placeholder') != this.value) {
                if ($(this).hasClass('selectpicker')) {
                    fdata[this.name] = $(this).val();   
                } else {
                    fdata[this.name] = this.value;  
                }
            }           
        });
        
        fdata['__abo_name__'] = $("#radar_name").val();
        fdata['__abo_id__'] = $("#abo_id").val();

        $.ajax({
            url: '/my-update_abo',
            type: 'POST',
            dataType : 'json',
            data: fdata,
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },            
            success: function(response, textStatus) {                   
                $("#msg").html(response.msg);
                if (response.err) {
                    $("#msg").removeClass("success");
                    $("#msg").addClass("error");
                } else {
                    $("#msg").removeClass("error");
                    $("#msg").addClass("success");                    
                }
            }
        });             

    });

    $("#abo-form #abo-show-params").click(function() {
        $("#abo-form .abo-param").parents(".form-group").show("slow");
        $(this).hide();
    });
    $("#abo-form .abo-param").change(function() {
        let params = JSON.parse(atob($("#abo-form #params").val()));
        let name = $(this).attr("name");
        if (!$(this).is("select") && ['radio', 'checkbox'].indexOf($(this).attr("type")) >= 0) {
            params[name] = $(this).is(":checked") ? '1' : '0';
        } else {
            params[name] = $(this).val()
        }
        $("#abo-form #params").val(btoa(JSON.stringify(params)));
    });

    // Captcha erneuern
    $('#popupShare').on('show.bs.modal', function (e) {
        $("#captcha").attr("src", "/ajax/captcha");
        let url = $(e.relatedTarget).data('url');
        if (url) {
            $("#sm_url").val(url);
        }
    });

    // Mail verschicken
    $("#btn-share-mail").click(function() {
        $.ajax({
            type: "POST",
            url: "/ajax/share_mail",
            dataType: "json",
            data: { sender_name: $("#sender_name").val(), sender_email: $("#sender_email").val(), recipient_name: $("#recipient_name").val(), recipient_email: $("#recipient_email").val(), comment: $("#comment").val(), sm_url: $("#sm_url").val(), code: $("#verify").val() },
            headers: { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },            
            success: function(response, textStatus) {
                if (response.error == "0") {
                    $("#msg_share_mail").html(response.msg);
                    $("#share_r1, #share_r2, #share_r3, #share_r4").css("display", "none");
                    $("#btn-share-mail").css("display", "none");
                    $("#btn-share-close").css("display", "block");
                } else {
                    $("#captcha").prop("src", "/ajax/captcha?" + Math.random());
                    $("#msg_share_mail").html(response.msg);
                }
            }
        });
    });

    // Mail verschicken - Enter
    $("#verify").keypress(function(e) {
        if (e.which == "13") {
            e.preventDefault();
            $("#btn-share-mail").trigger("click");
        }
    });

    if ($('#toolbar').length) {

        $("#totop").toggle($("#toolbar .tools").hasClass("fixed-top"));
        $("#totop").click(function() {
            $("html, body").animate({ scrollTop: "0px" }, 1000);
        });

        $(window).scroll(function() {   
            var window_top = $(this).scrollTop() + 1;
            let stucked =  window_top >= Math.floor($("#toolbar").offset().top);
            $("#toolbar.sticky .tools").toggleClass("fixed-top", stucked);
            if (stucked) {
                $("#toolbar.sticky").css("margin-bottom", $("#toolbar .tools").outerHeight(true));
                $("#totop").fadeIn(250);
            } else {
                $("#toolbar.sticky").css("margin-bottom", ''); 
                $("#totop").fadeOut(250);
            }
            var distance = 70;

            if ($("#pos1").length) {
                var pos_top = $("#pos1").offset().top;
                if (window_top + distance >= pos_top) {
                    if (!$("#link1").hasClass("active")) {
                        $(".link").removeClass("active");
                        $("#link1").addClass("active");
                    }
                } else {
                    if ($("#link1").hasClass('active')) {
                        $("#link1").removeClass('active');
                    }                
                }
            }

            if ($("#pos2").length) {
                var pos_top = $("#pos2").offset().top;
                if (window_top + distance >= pos_top) {
                    if (!$("#link2").hasClass("active")) {
                            $(".link").removeClass("active");
                        $("#link2").addClass("active");
                    }
                } else {
                    if ($("#link2").hasClass("active")) {
                        $("#link2").removeClass("active");
                    }                
                }
            }

            if ($("#pos3").length) {
                var pos_top = $("#pos3").offset().top;
                if (window_top + distance >= pos_top) {
                    if (!$("#link3").hasClass("active")) {
                            $(".link").removeClass("active");
                        $("#link3").addClass("active");
                    }
                } else {
                    if ($("#link3").hasClass("active")) {
                        $("#link3").removeClass("active");
                    }                
                }
            }

            if ($("#pos4").length) {
                var pos_top = $("#pos4").offset().top;
                if (window_top + distance >= pos_top) {
                    if (!$("#link4").hasClass("active")) {
                            $(".link").removeClass("active");
                        $("#link4").addClass("active");
                    }
                } else {
                    if ($("#link4").hasClass("active")) {
                        $("#link4").removeClass("active");
                    }                
                }
            }

            if ($("#pos5").length) {
                var pos_top = $("#pos5").offset().top;
                if (window_top + distance >= pos_top) {
                    if (!$("#link5").hasClass("active")) {
                            $(".link").removeClass("active");
                        $("#link5").addClass("active");
                    }
                } else {
                    if ($("#link5").hasClass("active")) {
                        $("#link5").removeClass("active");
                    }                
                }
            }

            if ($("#pos6").length) {
                var pos_top = $("#pos6").offset().top;
                if (window_top + distance >= pos_top) {
                    if (!$("#link6").hasClass("active")) {
                            $(".link").removeClass("active");
                        $("#link6").addClass("active");
                    }
                } else {
                    if ($("#link6").hasClass("active")) {
                        $("#link6").removeClass("active");
                    }                
                }
            }

        });
        
    }

    //Sources "durchprobieren" bis eventuell das img als Fallback dient
    $("picture img").on("error", function() {
	    $(this).parent("picture").find("source").first().remove();
    });
    $("picture source + img").each(function() {
        $(this).attr("src", $(this).attr("src"));
    });
});

/**
 * Alle Fixed-Spacer anpassen
 */
window.adjustFixedSpacer = function() {
    $(".fixed-top").each(function() {
        $(this).siblings(".fixed-spacer").css({ 'margin-top': $(this).outerHeight() });
    })
}

/**
 * Sources "durchprobieren" bis eventuell das img als Fallback dient
 * @param {*} parent 
 */
 window.checkSources = function(parent) {
    $(parent).find("picture img").on("error", function() {
        $(this).parent("picture").find("source").first().remove();
    });
    $(parent).find("picture source + img").each(function() {
        $(this).attr("src", $(this).attr("src"));
    });
}

/**
 * Bilder nachladen
 * @param {*} parent 
 */
window.deferredSrc = function(parent) {
    $(parent).find("source[data-deferred-srcset]").each(function() {
        $(this).attr("srcset", $(this).data("deferred-srcset"));
        $(this).removeAttr("data-deferred-srcset");
    });
    $(parent).find("img[data-deferred-src]").each(function() {
        $(this).attr("src", $(this).data("deferred-src"));
        $(this).removeAttr("data-deferred-src");
    });
}

/**
*   Ein bestimmtes Tipp-Modul ein- und ausklappbar machen
*/
window.makeTippCollapsable = function (tippElement, show) {
    show = Boolean(show || $(tippElement).find('.tipp.active:not(.all)').length);
    $(tippElement).find('.tag-cloud-content').collapse({toggle:false}).addClass("collapse").toggleClass("show", show);

    $(tippElement).find('.tag-cloud-content').on('show.bs.collapse', function () {
        $(this).siblings('.tag-cloud-headline').addClass('active');
    });
    $(tippElement).find('.tag-cloud-content').on('hide.bs.collapse', function () {
        $(this).siblings('.tag-cloud-headline').removeClass('active');
    });

    $(tippElement).find('.tag-cloud-headline').toggleClass('active', show);
    $(tippElement).find('.tag-cloud-headline').click(function() {
        $(this).siblings('.tag-cloud-content').collapse('toggle');
    });
    
}


window.recordOutboundLink = function (category, action, con) {

    action = action.toLowerCase();
    action = action.replace(/^https?:\/\//, '');

    var id = Math.floor(new Date().getTime() * Math.random() * 10000);
    if (typeof ga !== 'undefined') {
        ga('ecommerce:addTransaction', {
            id: id,             // Transaction ID*
            affiliation: '',    // Store Name
            revenue: con,       // Total
            shipping: '',       // Shipping
            tax: ''             // Tax
        });

        ga('ecommerce:addItem', {
            id: id,             // Transaction ID*
            sku: action,        // Product SKU
            name: action,       // Product Name*
            category: category, // Product Category
            price: con,         // Price (individual price)
            quantity: '1'       // Quantity
        });
        ga('ecommerce:send');
    } else {
        try {
            var id = Math.floor(new Date().getTime() * Math.random() * 10000);
            _gaq.push(['_addTrans', id, '', con, '', '', '', action, category]);
            _gaq.push(['_addItem', id, action, action, category, con, '1']);
            _gaq.push(['_trackTrans']);

        }
        catch(err){}
    }
}

window.dv = function (value) {
    return (value >> 4) / 1000;
}

window.toggle_cb = function () {
    $("input:checkbox").each(function() {
        if ($(this).is(":checked")) {
            $(this).prop("checked",false)
        } else {
            $(this).prop("checked",true)
        }
    });
}   

window.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

window.getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

window.debounce = (func, wait) => {  
    let debounceTimer;
    return function() {  
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), wait);
    }  
}


// WEBPACK FOOTER //
// ./resources/js/main.js